import api from '@/api'

const state = {
  admins: [],
  adminDetail: {}
}
const actions = {
  getAdmin({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.admin.adminList(params).then(
        response => {
          commit('setAdmins', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getAdminDetail({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      api.admin.adminDetail(id).then(
        response => {
          commit('setAdminDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createAdmin({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.admin.createAdmin(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setAdmins(state, value) {
    state.admins = value
  },
  setAdminDetail(state, value) {
    state.adminDetail = value
  }
}
const getters = {
  admins: state => state.admins,
  adminDetail: state => state.adminDetail
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
